import { Button } from '@wot/components';
import { Link, useNavigate } from 'react-router-dom';
import { Student } from '.';
import { DEFAULT_PROFILE_PIC } from '../../assets/icons';

function StudentCard({ student }: { student: Student }) {
  const navigate = useNavigate();
  return (
    <div className="w-full md:w-max flex md:shrink-0">
      {/* <Link to={`/find-tutor/${plan.tutorId}`} className="w-full"> */}
      <div className="w-full h-full md:w-[300px] flex flex-col border border-neutralGray3 p-4 rounded-lg cursor-pointer hover:bg-neutralBlue2">
        <div className="h-full flex flex-col gap-4 items-start md:items-center md:px-10 py-4">
          <Link to={student.user._id}>
            <div className="flex md:flex-col items-center gap-2">
              <div className="h-10 w-10 md:h-16 md:w-16 rounded-full overflow-hidden">
                <img
                  src={student.user.profilePic || DEFAULT_PROFILE_PIC}
                  alt="tutor_profile_pic"
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-2xl font-normal">{student.user.name}</span>
              <div className="flex flex-wrap">
                {student.category.name.map((course) => (
                  <div key={course} className="bg-neutralBlue2 px-3 py-1 text-sm rounded-full">
                    {course}
                  </div>
                ))}
              </div>
            </div>
          </Link>
          <div className="w-full max-w-sm mx-auto mt-auto flex flex-col gap-4 items-center justify-center whitespace-nowrap">
            <Button
              onClick={() =>
                navigate('/inbox', {
                  state: { _id: student.user._id, name: student.user.name, profilePic: student.user.profilePic }
                })
              }
              block
              text="Message"
              type="secondary"
              size="sm"
            />
          </div>
        </div>
      </div>
      {/* </Link> */}
    </div>
  );
}

export default StudentCard;
